<template>
  <div class="power-bi">
    <vx-card class="lead-listing" :title="$t('labels.power_bi')">
      <div class="flex justify-end addbtn-col sm: mb-0 md:mb-6">
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus"
          class="float-right btn-add sm: mb-6 md:m-0" v-if="checkPermission('power-bi', 'add')"
          @click="openAddReport">{{ $t("labels.add_report_url") }}</vs-button>
      </div>
      <vs-table :data="powerBiRecords" class="permission">
        <template slot="thead">
          <vs-th class="col-md-6">{{ $t("labels.report_url") }}</vs-th>
          <vs-th class="col-md-3">{{ $t("labels.organisation_name") }}</vs-th>
          <vs-th class="col-md-3">{{ $t("labels.date") }}</vs-th>
          <vs-th class="col-md-3">{{ $t("labels.action") }}</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="mw-250 text-truncate">{{ tr.url }}</vs-td>
            <vs-td class="text-truncate">
              {{ getOrganisationName(tr.organisation_id) || '-' }}
            </vs-td>
            <vs-td class="col-md-4">{{
              tr.created_at | only_date_format
              }}</vs-td>
            <vs-td class="col-md-4">
              <vs-button type="flat" :title="$t('labels.view')" size="large" icon-pack="feather" icon="icon-eye"
                color="dark" @click="openViewReport(tr)"></vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <vs-popup v-if="addReportPopup.isShow" :title="addReportPopup.title" class="another-popup"
      :active.sync="addReportPopup.isShow">
      <div class="vx-row w-full m-0 mb-4">
        <div class="vx-col sm: w-full md:w-full mb-4 pl-0">
          <label>{{ addReportPopup.message }}</label>
          <vs-textarea class="w-full mt-1" name="name" v-model="addReportPopup.data.url" />
          <label class="mt-4 block">Organisation Name</label>
          <v-select class="mt-1" v-validate="'required'" v-model="addReportPopup.data.organisation_id"
            :options="organisations" name="organisation_id" label="name" :reduce="org => org.id" />
        </div>
      </div>
      <div class="flex justify-end mt-4">
        <vs-button type="border" @click="popupCallback(false)">{{
          addReportPopup.buttons[0]
          }}</vs-button>
        <vs-button class="ml-5" id="uploadReportBtn" @click="popupCallback(true)">{{ addReportPopup.buttons[1]
          }}</vs-button>
      </div>
    </vs-popup>

    <vs-popup v-if="viewReportPopup.isShow" :title="viewReportPopup.title" class="another-popup"
      :active.sync="viewReportPopup.isShow" fullscreen>
      <div class="vh-100">
        <iframe :src="viewReportPopup.url" title="Sample Report Demo" width="100%" height="100%" frameborder="0"
          allowFullScreen="true"></iframe>
      </div>
    </vs-popup>
  </div>
</template>
<script>
export default {
  data() {
    return {
      powerBiRecords: [],
      addReportPopup: {
        data: {
          url: '',
          organisation_id: '',
        },
        isShow: false,
        title: "Add Report",
        message: "Power-BI Report URL",
        buttons: ["Cancel", "Update"],
      },
      viewReportPopup: {
        isShow: false,
        title: "Power-BI Report",
        url: null,
      },
      organisations: [],
    };
  },
  methods: {
    openAddReport() {
      this.addReportPopup.data = {
        url: '',
        organisation_id: '',
      };
      this.addReportPopup.isShow = true;
    },
    getOrganisationName(orgId) {
      const org = this.organisations.find(o => o.id === orgId);
      return org ? org.name : null;
    },
    openViewReport(data) {
      this.viewReportPopup.isShow = true;
      this.viewReportPopup.url = data.url;
    },
    async fetchOrganisations() {
      try {
        let response = await this.getHTTPPostResponse('/organizations/list');
        this.organisations = response.data.organizations; // Adjust based on API structure
      } catch (error) {
        console.error("Failed to fetch organisations", error);
      }
    },
    async popupCallback(action) {
      this.addReportPopup.isShow = false;
      if (action) {
        const payload = {
          url: this.addReportPopup.data.url,
          organisation_id: this.addReportPopup.data.organisation_id || null,
        };
        const res = await this.getHTTPPostResponse("dashboard/power-bi", payload, null, true);
        if (res.status == 200) {
          this.getPowerBi();
        }
      }
    },
    async getPowerBi() {
      const res = await this.getHTTPGetResponse("dashboard/power-bi");
      if (res.status == 200) {
        console.log(res);
        this.powerBiRecords = res.data.powerBi;
      }
    },
  },
  mounted() {
    this.getPowerBi();
    this.fetchOrganisations();
  },
};
</script>
<style scoped>
.mw-250 {
  max-width: 250px !important;
}
</style>
